import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { styled } from "@mui/system";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const StyledCard = styled(Card)({
  maxWidth: 440,
  background: "#fff",
  padding: ".5rem",
  height: "22rem",
  marginBottom: "2rem",
  // width:250
  position: "relative",
});

const StyledCardMediaWrapper = styled("div")({
  position: "relative",
  width: "100%",
  height: "140px",
});

const StyledCardMedia = styled(CardMedia)({
  position: "absolute",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  objectFit: "cover",
});

const IconWrapper = styled("div")({
  position: "relative",
  top: "50%",
  left: "86%",
  transform: "translate(-50%, -50%)",
});

const StyledButton = styled(Button)({
  position: "absolute",
  bottom: "1rem",
  right: "1rem",
});

const StyledCardContent = styled(CardContent)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  // height: "calc(100% - 1000px)",
});

export default function HomeCommonCard({
  backgroundColor,
  image,
  title,
  description,
  Icon,
  handleNavigate,
}) {
  const { t } = useTranslation();

  return (
    <StyledCard>
      <StyledCardMediaWrapper style={{ backgroundColor: backgroundColor }}>
        <StyledCardMedia component="img" alt="Card Image" image={image} />
        <IconWrapper>
          {Icon} {/* Replace Icon with your actual icon component */}
        </IconWrapper>
      </StyledCardMediaWrapper>

      <StyledCardContent>
        <Typography gutterBottom variant="h6" component="div">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </StyledCardContent>
      <CardActions>
        <StyledButton size="small" variant="outlined" onClick={handleNavigate}>
          <Typography variant="span" sx={{ paddingRight: "1rem" }}>
            {t("Go To Screen")}
          </Typography>
          <ArrowForwardOutlinedIcon sx={{ paddingLeft: ".1rem" }} />
        </StyledButton>
      </CardActions>
    </StyledCard>
  );
}
